import { useContext } from 'react';

import CreateWorkModalContext from '../../CreateWorkModalContext';
import {
  clearRequiredFieldIds,
  updateFieldValueById,
} from '../../createWorkModalUtilities';

import CustomFieldRow from './CustomFieldRow';

import classes from './workDetails.module.css';

const CustomFields = () => {
  const { draft, updateDraftField, requiredFieldIds, setRequiredFieldIds } =
    useContext(CreateWorkModalContext);
  const { fields, fieldOrder } = draft;

  const handleChange = (fieldId: string, value: any) => {
    const updatedFields = updateFieldValueById(fields, fieldId, value);

    setRequiredFieldIds(
      clearRequiredFieldIds(requiredFieldIds, fieldId, updatedFields),
    );

    return updateDraftField('fields', updatedFields);
  };

  const mappedFields = fieldOrder.map(fieldId =>
    fields.find(item => item.id === fieldId),
  );

  return (
    <div className={classes.customFields}>
      {mappedFields.map(field => (
        <CustomFieldRow key={field.id} field={field} onChange={handleChange} />
      ))}
    </div>
  );
};

export default CustomFields;
